const isFrenchMultilingualSite = (
  locale: string,
) => ['fr-BE', 'fr-CA'].includes(locale);

export default isFrenchMultilingualSite;
